import React from "react";
import StockMovementFlow from "../components/StockMovementFlow";

export default function Wareneingang() {
  return (
    <StockMovementFlow
      title="Wareneingang"
      color="green"
      endpoint="/goods-receipts"
      transfer={false}
      showPrice
      testIdPrefix="we"
    />
  );
}
